import styled from '@emotion/styled';
import { TextField as TextInput } from '../index';

export const Container = styled.div``;

export const FullWidthTextField = styled(TextInput)`
  width: initial;
`;
